module.exports = __webpack_public_path__ + "img/xtrz.2a184b7f.svg";